import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Phone, Menu, X } from 'lucide-react';
import '../styles/components/Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 860) {
        setIsMenuOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  return (
    <header className="header">
      <nav className="nav">
        <div className="nav-brand">
          <Link to="/" className="logo">SAP Movers</Link>
          <button
            type="button"
            className="nav-toggle"
            aria-expanded={isMenuOpen}
            aria-controls="primary-navigation"
            aria-label={isMenuOpen ? 'Close navigation menu' : 'Open navigation menu'}
            onClick={toggleMenu}
          >
            <span className="sr-only">Toggle navigation</span>
            {isMenuOpen ? <X size={22} aria-hidden="true" /> : <Menu size={22} aria-hidden="true" />}
          </button>
        </div>

        <div
          id="primary-navigation"
          className={`nav-collapsible${isMenuOpen ? ' open' : ''}`}
          aria-hidden={!isMenuOpen}
        >
          <ul className="nav-links">
            <li><Link to="/moving">Moving Services</Link></li>
            <li><Link to="/junk-removal">Junk Removal</Link></li>
            <li><Link to="/contact">Contact</Link></li>
            
          </ul>
          <div className="nav-actions">
            <a href="tel:18059403979" className="nav-phone">
              <span className="nav-phone-icon"><Phone size={18} strokeWidth={2} /></span>
              <span className="nav-phone-details">
                <span className="nav-phone-number">(805) 940-3979</span>
              </span>
            </a>
            <Link to="/contact" className="cta-button nav-cta">Get a Free Quote</Link>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
